import { useState, useEffect } from "react";

export const useSectionsData = () => {
  const [sections, setSections] = useState(window?.post_template);

  useEffect(() => {
    if (window?.post_template && !sections) {
      setSections(window.post_template);
    }
  }, [sections]);

  return sections;
};
